"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const multiSig = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'msgSender',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'otherSigner',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'operation',
                type: 'bytes32'
            }
        ],
        name: 'BatchTransacted',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'sender',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'recipient',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256'
            }
        ],
        name: 'BatchTransfer',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'from',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256'
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'data',
                type: 'bytes'
            }
        ],
        name: 'Deposited',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'msgSender',
                type: 'address'
            }
        ],
        name: 'SafeModeActivated',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'msgSender',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'otherSigner',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'operation',
                type: 'bytes32'
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'toAddress',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256'
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'data',
                type: 'bytes'
            }
        ],
        name: 'Transacted',
        type: 'event'
    },
    {
        stateMutability: 'payable',
        type: 'fallback'
    },
    {
        inputs: [],
        name: 'activateSafeMode',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address payable',
                name: 'forwarderAddress',
                type: 'address'
            },
            {
                internalType: 'address',
                name: 'tokenContractAddress',
                type: 'address'
            }
        ],
        name: 'flushForwarderTokens',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'getNextSequenceId',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'allowedSigners',
                type: 'address[]'
            }
        ],
        name: 'init',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'initialized',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'signer',
                type: 'address'
            }
        ],
        name: 'isSigner',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'safeMode',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'toAddress',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256'
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes'
            },
            {
                internalType: 'uint256',
                name: 'expireTime',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'sequenceId',
                type: 'uint256'
            },
            {
                internalType: 'bytes',
                name: 'signature',
                type: 'bytes'
            }
        ],
        name: 'sendMultiSig',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'recipients',
                type: 'address[]'
            },
            {
                internalType: 'uint256[]',
                name: 'values',
                type: 'uint256[]'
            },
            {
                internalType: 'uint256',
                name: 'expireTime',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'sequenceId',
                type: 'uint256'
            },
            {
                internalType: 'bytes',
                name: 'signature',
                type: 'bytes'
            }
        ],
        name: 'sendMultiSigBatch',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'toAddress',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256'
            },
            {
                internalType: 'address',
                name: 'tokenContractAddress',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: 'expireTime',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'sequenceId',
                type: 'uint256'
            },
            {
                internalType: 'bytes',
                name: 'signature',
                type: 'bytes'
            }
        ],
        name: 'sendMultiSigToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        name: 'signers',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        stateMutability: 'payable',
        type: 'receive'
    }
];
exports.default = multiSig;
